import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
const componentsFiles = require.context(
  './',
  true,
  /Common[A-Z]\w+\.(vue|js)$/
)
let components = {}

componentsFiles.keys().forEach(fileName => {
  // 获取组件配置
  const componentConfig = componentsFiles(fileName)
  // 获取组件的 PascalCase 命名
  const componentName = upperFirst(
    camelCase(
      // 获取和目录深度无关的文件名
      fileName
        .split('/')
        .pop()
        .replace(/\.\w+$/, '')
    )
  )
  components[componentName] = componentConfig.default || componentConfig
})
export default Vue => {
  for (let key in components) {
    Vue.component(key, components[key])
  }
}
